module.exports = __webpack_public_path__ + "img/OTP_Illustrations.a7f39b9c.svg";